import { render } from "./TeamDashboard.vue?vue&type=template&id=f5ad2064&scoped=true"
import script from "./TeamDashboard.vue?vue&type=script&lang=js"
export * from "./TeamDashboard.vue?vue&type=script&lang=js"

import "./TeamDashboard.vue?vue&type=style&index=0&id=f5ad2064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ad2064"]])

export default __exports__